export default __webpack_public_path__ + "static/EarnPage-Core-mobile-withPhone 2-2259621ce94b1c91a34be99b0092af4c.png";